import { FormattedNumber } from 'react-intl';
import { ReactElement } from 'react';

export interface FractionDigitsFormattedNumberProps {
    value: number;
    currency: string;
}

export const FractionDigitsFormattedNumber = (props: FractionDigitsFormattedNumberProps): ReactElement => {
    const { value, currency } = props;

    return (
        <FormattedNumber
            value={value}
            minimumFractionDigits={2}
            maximumFractionDigits={value < 1 ? 4 : 2}
            currency={currency}
            style="currency"
        />
    );
};
